import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { fetchChildren } from "../services/Api"; // or adjust path if needed
import { useAuth } from "../services/AuthContext";
import { useRefresh } from "../services/RefreshContext"; // Import the refresh hook

function Header() {
  const { auth, username, checkAuth, familyID, childID, updateChildID } = useAuth();
  const { refreshCounter, triggerRefresh } = useRefresh();
  const navigate = useNavigate();
  const location = useLocation();

  const [children, setChildren] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [childName, setChildName] = useState("Loading...");

  const handleLogout = async () => {
    localStorage.removeItem("token");
    await checkAuth();
    navigate("/");
  };

  const goBackPages = [
    "/selectchild",
    "/savings",
    "/jobs",
    "/lessons",
    "/investments",
  ];

  const showChildDropdownPages = [
    "/savings",
    "/jobs",
    "/lessons",
    "/investments"
  ];

  useEffect(() => {
    const getChildren = async () => {
      if (!familyID) return;
      
      setIsLoading(true);
      try {
        const result = await fetchChildren(familyID);
        setChildren(result);
        
        // Auto-select first child if no child is selected and there is at least one child
        if (!childID && result.length > 0) {
          updateChildID(result[0].ChildID);
        }
      } catch (err) {
        console.error("Failed to fetch children", err);
      } finally {
        setIsLoading(false);
      }
    };

    getChildren();
  }, [familyID, refreshCounter, updateChildID]);

  useEffect(() => {
    if (isLoading) return;
    
    if (children.length > 0 && childID) {
      const selected = children.find(c => String(c.ChildID) === String(childID));
      if (selected) {
        setChildName(selected.FirstName);
      } else if (children.length > 0) {
        // If no match but we have children, show first child
        setChildName(children[0].FirstName);
        // Optionally update childID to match first child
        updateChildID(children[0].ChildID);
      } else {
        setChildName("Select Child");
      }
    } else {
      setChildName("Select Child");
    }
  }, [children, childID, isLoading, updateChildID]);

  const showGoBack = goBackPages.includes(location.pathname);

  return (
    <>
      {/* Topbar */}
      <nav className={`headerBackgroundColor navbar navbar-expand navbar-light bg-white topbar static-top shadow 
        ${location.pathname === "/" ? "mb-0" : "mb-4"}`}>
        <div className="container-fluid d-flex justify-content-between align-items-center w-100">

          {/* LEFT: Logo + Title */}
          <div className="d-flex align-items-center">
            <Link to={auth ? "/landingpage" : "/"} style={{ textDecoration: "none" }}>
              <img
                style={{ height: "50px", marginLeft: "12px", marginRight: "5px" }}
                src="../piggylogo.ico"
                alt="Piggy Logo"
              />
            </Link>

            <Link
              to={auth ? "/landingpage" : "/"}
              className="headerButton"
              style={{ textDecoration: "none", fontFamily: "PiggyFontBold" }}
            >
              PIGGYMATE
            </Link>
          </div>

          {/* CENTER: Child Dropdown */}
          <div
            className="position-absolute start-50 translate-middle-x"
            style={{ zIndex: 999 }}
          >
            {showChildDropdownPages.includes(location.pathname) && children.length > 0 && (
              <div className="dropdown">
                <button
                  className="btn dropdown-toggle text-gray-600"
                  id="childDropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{
                    fontSize: "2rem",
                    fontWeight: "600", 
                    color: "#333",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    textAlign: "center"
                  }}
                >
                  {isLoading ? "Loading..." : childName}
                  <i className="fas fa-child ms-2 text-gray-600"></i>
                </button>
                <div
                  className="dropdown-menu shadow animated--grow-in text-center"
                  aria-labelledby="childDropdown"
                  style={{
                    width: "300px",
                    minWidth: "300px",
                  }}
                >
                  {children.map(child => (
                    <button
                      key={child.ChildID}
                      className={`dropdown-item ${String(child.ChildID) === String(childID) ? "blue-color text-white" : ""}`}
                      style={{ fontSize: "20px" }}
                      onClick={() => updateChildID(child.ChildID)}
                    >
                      {child.FirstName}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* RIGHT: Back + Profile */}
          <div className="d-flex align-items-center">
            {showGoBack && (
              <button
                className="edit-btn p-1 dark-blue-color me-3 px-3"
                onClick={() => navigate("/landingpage")}
              >
                ← Home
              </button>
            )}

            {auth ? (
              <div className="nav-item dropdown no-arrow">
                <button
                  className="nav-link dropdown-toggle"
                  id="userDropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                    {username}
                  </span>
                  <img
                    className="img-profile rounded-circle"
                    src="img/Grimmace.png"
                    alt="User Profile"
                  />
                </button>
                <div
                  className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                  aria-labelledby="userDropdown"
                >
                  <Link to="/grownups" style={{ fontSize: "17px" }} className="dropdown-item">Grown Ups</Link>
                  <Link to="/selectchild" style={{ fontSize: "17px" }} className="dropdown-item">Kids</Link>
                  <div className="dropdown-divider" />
                  <button className="dropdown-item" onClick={handleLogout}>
                    <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
                    Logout
                  </button>
                </div>
              </div>
            ) : (
              <Link to="/login" className="navbar-nav ml-auto mr-5">Log in</Link>
            )}
          </div>
        </div>
      </nav>

    </>
  );
}

export default Header;
